import * as React from 'react';
import Icons from '../icons';

export default class Emptyworkkard extends React.Component {
    constructor(props){
        super(props);
    }

    render(){
        return(
            <div className="emptyScreen">
                <Icons name="Emptyworkkard" className="" /> <br />   
                <h2>No workkards found</h2>
            </div>
        );
    }
}